// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"buildcontrol_BuildControl__3i0Tc","Label":"buildcontrol_Label__3OOk-","Less":"buildcontrol_Less__2ldGN","More":"buildcontrol_More__1qrUR"};